module.exports = __webpack_public_path__ + "img/aliPay.9ce6cb89.png";